import React from 'react';
import { withRouter } from 'react-router';
import { isEmpty } from 'lodash';
import { Container } from 'shared-components/grid';

import styles from './styles';

@withRouter
export default class MachineBoxContainer extends React.Component {
  state = {
    machineBoxWidgetId: '',
  };

  componentDidMount() {
    if (!isEmpty(this.state.machineBoxWidgetId)) return;
    const widgetId = window.aiware.mountWidget({
      name: 'MACHINE_BOX_BROWSE',
      elementId: 'machine-box-browse',
      config: {
        baseRedirectUrl: window.location.origin,
      },
    });
    this.setWidgetId(widgetId);
  }

  componentWillUnmount() {
    window.aiware.unmountWidget(this.state.machineBoxWidgetId);
  }

  setWidgetId = (id) => {
    this.setState({ machineBoxWidgetId: id });
  };

  render() {
    return (
      <Container sideBarOffset className={styles['mb-container']}>
        <div id="machine-box-browse" className={styles['mb-iframe']} />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/machine-box/components/MachineBoxContainer.js